const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
    // api: "https://quyhoachtphcm-apidev.cgis.asia/",
    api: "https://quyhoachtinhphutho-api.c2tech.vn/",
    domainAdminSide: "http://localhost:3000",
    domainUserSide: "http://localhost:3001",
  },
  production: {
    // api: "https://quyhoachtphcm-apidev.c2tech.vn/",
    api: "https://quyhoachtinhphutho-api.c2tech.vn/",
    domainAdminSide: "http://admin.quyhoachtinhphutho.c2tech.vn",
    domainUserSide: "http://quyhoachtinhphutho.c2tech.vn",
  },
};

module.exports = apiEnvironment[env];
